import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "react-modal";

import MediaListSlickComponent from "../../Community/MediaListSlick/MediaListSlickComponent";
import { getUserAllowedLanguages, purifyString } from "Utils";
import { saveAlbum } from "Thunks";
import {
  resetAlbumEditor,
  setAlbumEditor,
  displaySidebarAlbums,
  removeMediaFromAlbumMedias,
  setFetchingItems,
  resetSelectedMedia
} from "Actions";
import Button from "Common/Button/Button";
import Loader from "Common/Loader/Loader";
import Checkmark from "Common/Checkmark/Checkmark";
import ArrowLeftIcon from "Common/ArrowLeftIcon";
import ArrowRightIcon from "Common/ArrowRightIcon";
import Tabs from "Tabs/TabsComponent";
import FormInput from "Common/FormInput";
import TagsInput from "Common/TagsInput";
//import { TTP_API_URL } from "Config";
import _ from "i18n";

const customStyles = {
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "none",
    overflow: "none",
    padding: 0,
    top: "5%",
    left: "5%",
    right: "5%",
    bottom: "5%",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(41, 57, 77, 0.04)"
  }
};

Modal.setAppElement("#app");
Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.75)";

export class AlbumEditor extends Component {
  titleInput = React.createRef();
  descriptionInput = React.createRef();

  state = {
    tag: null,
    currentColor: this.props.color,
    savingState: "default",
    savingError: null,
    titleCurrentTab: null,
    descriptionCurrentTab: null
  };

  static propTypes = {
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    medias: PropTypes.array
  };

  componentDidUpdate(prevProps, prevState) {
    const { color } = this.props;

    if (prevProps.color !== color) {
      this.setState({ currentColor: color });
    }
  }

  componentDidMount() {
    const languages = this.getUserLanguages();
    this.setState({
      titleCurrentTab: languages[0],
      descriptionCurrentTab: languages[0]
    });
  }

  afterOpenModal = () => {};

  closeModal = () => {
    const { resetAlbumEditor } = this.props;

    this.setState({
      savingState: "default",
      savingError: null,
      titleCurrentTab: null,
      descriptionCurrentTab: null
    });

    setTimeout(e => {
      resetAlbumEditor();
    }, 0);
  };

  removeMediaFromAlbum = (id, e) => {
    //TODO on doit remplacer confim par react_modal
    if (
      window.confirm(
        _("Do you really want to remove this image from the album")
      )
    ) {
      const { removeMediaFromAlbumMedias } = this.props;

      removeMediaFromAlbumMedias(id);
    }
  };

  handleSave = () => {
    const {
      checks,
      titleFR,
      titleEN,
      titleNL,
      descriptionFR,
      descriptionEN,
      descriptionNL,
      color,
      id,
      tags,
      medias,
      saveAlbum,
      displaySidebarAlbums,
      setFetchingItems,
      resetSelectedMedia
    } = this.props;

    this.setState({ savingState: "saving" });

    saveAlbum({
      id,
      titleFR,
      titleEN,
      titleNL,
      descriptionFR,
      descriptionEN,
      descriptionNL,
      color,
      tags,
      mediaIds: id
        ? medias.map(media => media.id)
        : checks.map(media => media.id)
    })
      .then(resp => {
        if (id && resp.value && resp.value.data && resp.value.data.data) {
          setFetchingItems([resp.value.data.data]);
        }
        this.setState({ savingState: "success" }, () => {
          setTimeout(() => {
            this.closeModal();
            displaySidebarAlbums(false);
            resetSelectedMedia();

            // $(".check").addClass("disabled");
            // $(".check").css("display", "none");

            // const bubbles = document.getElementById("bubbles");
            // if (bubbles) {
            //   bubbles.classList.remove("active");
            // }
            // const albumArea = document.getElementById("album-area");
            // albumArea &&
            //   window.scrollTo(
            //     0,
            //     albumArea.getBoundingClientRect().top + window.scrollY
            //   );
          }, 3000);
        });
        // document
        //   .getElementsByClassName("close")
        //   .item(0)
        //   .click();
      })
      .catch(e => {
        this.setState({ savingState: "error", savingError: e });
        setTimeout(
          () => this.setState({ savingState: "default", savingError: null }),
          3000
        );
      });
  };

  handleTitleChange = e => {
    const { titleCurrentTab } = this.state;
    this.props.setAlbumEditor({
      [`title${titleCurrentTab}`]: e.currentTarget.value
    });
  };

  handleDescriptionChange = e => {
    const { descriptionCurrentTab } = this.state;
    this.props.setAlbumEditor({
      [`description${descriptionCurrentTab}`]: e.currentTarget.value
    });
  };

  handleColorChange(color, e) {
    $(".rmodal__albums-color li").removeClass("active");
    e.currentTarget.classList.add("active");

    this.props.setAlbumEditor({ color });
    return this.setState({ currentColor: color });
  }

  getUserLanguages() {
    const { navCommunity } = this.props;

    return getUserAllowedLanguages(navCommunity);
  }

  renderTitle() {
    const languages = this.getUserLanguages();
    const { titleCurrentTab } = this.state;
    const helpTitleLng = titleCurrentTab || languages[0];

    return (
      <React.Fragment>
        <div className="mini-tabs">
          {(languages.length > 1 ? languages : []).map(l => {
            return (
              <span
                key={l}
                className={l === helpTitleLng ? "active" : ""}
                onClick={() => {
                  this.setState({ titleCurrentTab: l });
                  this.titleInput.current.focus();
                }}
              >
                {_(l)}
              </span>
            );
          })}
        </div>
        <input
          className="cell small-8"
          type="text"
          name="title"
          ref={this.titleInput}
          value={this.props[`title${helpTitleLng}`]}
          onChange={this.handleTitleChange}
        />
      </React.Fragment>
    );
  }

  renderDescription() {
    const languages = this.getUserLanguages();
    const { descriptionCurrentTab } = this.state;
    const helpDescLng = descriptionCurrentTab || languages[0];

    return (
      <React.Fragment>
        <div className="mini-tabs">
          {(languages.length > 1 ? languages : []).map(l => {
            return (
              <span
                key={l}
                className={l === helpDescLng ? "active" : ""}
                onClick={() => {
                  this.setState({ descriptionCurrentTab: l });
                  this.descriptionInput.current.focus();
                }}
              >
                {_(l)}
              </span>
            );
          })}
        </div>
        <textarea
          className="cell small-8"
          rows="3"
          ref={this.descriptionInput}
          value={this.props[`description${helpDescLng}`]}
          onChange={this.handleDescriptionChange}
        />
      </React.Fragment>
    );
  }

  renderColorPalette() {
    const { color } = this.props;

    return (
      <ul className="rmodal__albums-color">
        <li
          className={`${parseInt(color, 10) === 1 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 1)}
        >
          <span
            style={{
              backgroundColor: "#FFCC66",
              borderColor: "#CCA352"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 2 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 2)}
        >
          <span
            style={{
              backgroundColor: "#56AADD",
              borderColor: "#2381B9"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 3 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 3)}
        >
          <span
            style={{
              backgroundColor: "#9EC865",
              borderColor: "#6BA051"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 4 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 4)}
        >
          <span
            style={{
              backgroundColor: "#D85A4A",
              borderColor: "#A53136"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 5 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 5)}
        >
          <span
            style={{
              backgroundColor: "#DA974F",
              borderColor: "#A7703B"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 6 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 6)}
        >
          <span
            style={{
              backgroundColor: "#BD8CD6",
              borderColor: "#8A63C2"
            }}
          />
        </li>
        <li
          className={`${parseInt(color, 10) === 7 ? "active" : ""}`}
          onClick={this.handleColorChange.bind(this, 7)}
        >
          <span
            style={{
              backgroundColor: "#AEB0B2",
              borderColor: "#7B879E"
            }}
          />
        </li>
      </ul>
    );
  }

  renderMedias() {
    const { checks, id, medias, fetching } = this.props;
    const editor = id ? true : false;
    const mediasList = id ? medias : checks;
    return (
      <div className="cell small-8 rmodal__left rmodal__left-album">
        {!id && <h4>{_("Selected media(s)")}</h4>}
        <section>
          <MediaListSlickComponent
            fetching={fetching}
            medias={mediasList}
            styleClass="large-3"
            stepMedia={4}
            editor={editor}
          />
        </section>
      </div>
    );
  }

  renderSaveBtn() {
    const { savingState } = this.state;
    // return (
    //   <button onClick={this.handleSave}>
    //     {saving ? _("Processing...") : _("Save")}
    //   </button>
    // );

    return (
      <div>
        {savingState === "default" && (
          <Button onClick={this.handleSave} block={true} type="submit">
            {_("Save")}
          </Button>
        )}

        {savingState === "saving" && (
          <Button variant="default" block={true}>
            <Loader
              color={"#000"}
              style={{
                width: "2rem",
                height: "2rem"
              }}
            />
          </Button>
        )}

        {savingState === "success" && (
          <Button variant="default" block={true}>
            <Checkmark
              style={{
                width: "2rem",
                height: "2rem"
              }}
            />
          </Button>
        )}

        {savingState === "error" && (
          <Button variant="danger" block={true}>
            {_("Error")}{" "}
          </Button>
        )}
      </div>
    );
  }

  handleIsPersonalChange = () => {
    this.props.setAlbumEditor({ isPersonal: !this.props.isPersonal });
  };

  handleChange = event => {
    const { value, name } = event.target;

    this.props.setAlbumEditor({
      [name]: value
    });
  };

  handleTagsChange = tags => {
    this.props.setAlbumEditor({ tags });
  };

  renderInput(name, lng) {
    const type = name === "description" ? "textarea" : "text";
    return (
      <FormInput
        className="cell small-8"
        ref={this[name + "Input"]}
        type={type}
        name={name + lng}
        label={_(name)}
        value={purifyString(this.props[name + lng])}
        onChange={this.handleChange}
      />
    );
  }

  renderTabs() {
    const languages = this.getUserLanguages();
    if (languages && languages.length > 1) {
      return (
        <Tabs>
          {languages.map(lng => (
            <div label={lng} icon={`/img/flags/${lng}.jpg`}>
              {this.renderInput("title", lng)}
              {this.renderInput("description", lng)}
            </div>
          ))}
        </Tabs>
      );
    } else if (languages && languages.length === 1) {
      return (
        <div label={languages[0]}>
          {this.renderInput("title", languages[0])}
          {this.renderInput("description", languages[0])}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { isOpen, withNav, id, tags } = this.props;
    if (!isOpen) {
      return false;
    }
    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        closeTimeoutMS={500}
        style={customStyles}
        contentLabel="Modal"
      >
        <div id="album-editor">
          <div className="rmodal ">
            <div className="rmodal__close">
              <button className="close " onClick={this.closeModal} />
            </div>
            {withNav ? (
              <div>
                <div className="rmodal__next">
                  <span className="next" onClick={this.handleClickNext}>
                    <ArrowRightIcon />
                  </span>
                </div>
                <div className="rmodal__previous">
                  <span className="previous" onClick={this.handleClickPrevious}>
                    <ArrowLeftIcon />
                  </span>
                </div>
              </div>
            ) : null}
            <div className="rmodal__header">
              <i className="icotam-folder" /> &nbsp;&nbsp;
              {id ? _("Edit album") : _("Add your media to an ALBUM")}
            </div>
            <div className="cell rmodal__body grid-x">
              {this.renderMedias()}
              <div className="cell small-4 rmodal__right">
                <div>
                  {!id && (
                    <div>
                      <h3>{_("Create a new album")}</h3>
                      <p className="desc">
                        {_(
                          "Give a title and add a description to your new ALBUM"
                        )}
                      </p>
                    </div>
                  )}

                  {this.renderTabs()}
                  <ul className="rmodal__right-form">
                    <li className="grid-y">
                      <label className="cell small-4">{_("Tags")}</label>
                      <div className="cell small-8">
                        <TagsInput
                          selectedTags={tags}
                          onChange={this.handleTagsChange}
                        />
                      </div>
                    </li>
                  </ul>
                  {/* <div
                    className="rmodal__right-form"
                    style={{ display: "flex" }}
                  >
                    <Switch
                      name="private"
                      isChecked={isPersonal}
                      onChange={this.handleIsPersonalChange}
                    />
                    <label style={{ marginLeft: "8px" }}>{_("Personal")}</label>
                  </div> */}
                </div>
                <div className="rmodal__right-actions">
                  <Button variant="default" onClick={this.closeModal}>
                    {_("Cancel")}
                  </Button>
                  {this.renderSaveBtn()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  navCommunity: state.auth.navCommunity,
  isOpen: state.albumEditor.isOpen,
  lng: state.params.lng,
  medias: state.albumEditor.medias,
  titleFR: state.albumEditor.titleFR,
  titleEN: state.albumEditor.titleEN,
  titleNL: state.albumEditor.titleNL,
  descriptionFR: state.albumEditor.descriptionFR,
  descriptionEN: state.albumEditor.descriptionEN,
  descriptionNL: state.albumEditor.descriptionNL,
  color: state.albumEditor.color,
  id: state.albumEditor.id,
  tags: state.albumEditor.tags,
  saving: state.albums.saving,
  saved: state.albums.saved,
  error: state.albums.error,
  checks: state.medias.listing.checks,
  fetching: state.albumEditor.fetching
});

const mapDispatchToProps = dispatch => ({
  saveAlbum: options => dispatch(saveAlbum(options)),
  resetAlbumEditor: () => dispatch(resetAlbumEditor()),
  setAlbumEditor: options => dispatch(setAlbumEditor(options)),
  displaySidebarAlbums: options => dispatch(displaySidebarAlbums(options)),
  setFetchingItems: options => dispatch(setFetchingItems(options)),
  resetSelectedMedia: () => dispatch(resetSelectedMedia()),
  removeMediaFromAlbumMedias: options =>
    dispatch(removeMediaFromAlbumMedias(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumEditor);



// WEBPACK FOOTER //
// ./src/components/Reveal/AlbumEditor/AlbumEditor.js